import axios from "axios";
import { appConstants } from "./appConstants";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken } from "./generic";

let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
}
let id;
if (JSON.parse(sessionStorage.getItem('LOGIN_DETAILS')) !== null) {
  id = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))._id
}

export const getBusinessUserContacts = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/fetchContacts", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getBusinessUserContacts===>", error?.response?.data?.Result_Message)
    })
}

export const deleteContactRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("deleteContact values", values);
  axios.post(appConstants.baseURL + "contact/deleteContact", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error deleteContact===>", error?.response?.data?.Result_Message)
    })
}


export const addContactData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/addContact", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("Error in addContactData: ", error.message)
    })
}

export const updateContactData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/updateContact", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("Error in updateContactData: ", error.message)
    })
}

export const getContactDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/fetchContactDetailsById", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error delete getCustomerByID===>", error.message)
    })

}
export const getAllContactsList = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/fetchAllContactsForMerge", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error delete getAllContacts===>", error.message)
    })

}

//Get Customer Activity Statements

export const getCustomerActivityStatements = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/fetchCustomerActivityStatements", values, axiosConfig).then(res => {
    callBack(res.data);
    dispatch(loadingAction(false));
    dispatch(IdleAction(new Date()));
  }).catch(error => {
    console.log("Customer Activity Statements Error: ", error);
    if (error.code === "ERR_NETWORK") {
      callBack({ Result_Status: false, Result_Message: "Service Unavailable, Please try again later." });
    }
    dispatch(loadingAction(false));
    console.log("Customer Activity Statements Error: ", error.message);

    // ✅ FIXED
    if (error?.response?.data?.Result_Message === "TokenExpiredError") {
      generateToken(id, dispatch);
    }

  })

}

export const MergeContactTransaction = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/mergeContactTransaction", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("Error While Merge Contact Transaction: ", error?.response?.data?.Result_Message)
    })
}

export const getEmailAndTemplateForContact = async (values, callBack, dispatch) => {

  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "contact/fetchContactEmailWithTemplate", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getEmailAndTemplateForQuotation===>", error?.response?.data?.Result_Message)
    })
}